/* eslint-disable */
export default {
  log: 'Registo',
} as const;

// @key: @#@"log"@#@ @source: @#@"Log"@#@
